import { keyframes } from '@vanilla-extract/css';
import { style } from '../layer.css';

const slideDown = keyframes({
  from: {
    height: 0,
  },
  to: {
    height: 'var(--radix-collapsible-content-height)',
  },
});

const slideUp = keyframes({
  from: {
    height: 'var(--radix-collapsible-content-height)',
  },
  to: {
    height: 0,
  },
});

export const content = style({
  overflow: 'hidden',
  selectors: {
    '&[data-state="open"]': {
      animationName: slideDown,
      animationTimingFunction: 'ease-out',
    },
    '&[data-state="closed"]': {
      animationName: slideUp,
      animationTimingFunction: 'ease-out',
    },
  },
});

export const trigger = style({
  selectors: {
    // https://synoptic0.slack.com/archives/C08CTHYQZ6C/p1761692569294159
    '&:is([aria-expanded="true"])': {
      backgroundColor: 'transparent',
    },
  },
});
